import { render, staticRenderFns } from "./fusepushform.vue?vue&type=template&id=640a5c54&scoped=true&"
import script from "./fusepushform.vue?vue&type=script&lang=js&"
export * from "./fusepushform.vue?vue&type=script&lang=js&"
import style0 from "./fusepushform.vue?vue&type=style&index=0&id=640a5c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640a5c54",
  null
  
)

export default component.exports